import { useAppAxios } from "../../app/hooks";
import { store } from "../../app/store";
import { getExtensionFromMimeType } from "./MimeUtils";

export const downloadBlob = (props: {
    blob: Blob;
    contentType?: string | null;
    fileName: string;
    extension?: string | null;
}): void => {
    const { blob, contentType, fileName } = props;
    const blobUrl = window.URL.createObjectURL(
        new Blob([blob], { type: contentType ?? undefined }),
    );

    let finalFileName = fileName;
    let extension = props.extension;
    if (!extension) {
        extension = getExtensionFromMimeType(contentType ?? undefined);
    }

    if (extension && !finalFileName.toLowerCase().endsWith(`.${extension}`)) {
        finalFileName = `${finalFileName}.${extension}`;
    }

    const link = document.createElement("a");
    link.href = blobUrl;
    link.setAttribute("download", finalFileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(blobUrl);
};

export const downloadFile = async (props: {
    url: string;
    fileName: string;
    extension?: string | null;
}): Promise<void> => {
    const { url, fileName } = props;
    const { extension } = props;

    if (!url) {
        return;
    }

    const { root } = store.getState();
    const { authToken } = root;

    try {
        const response = await useAppAxios.get(url, {
            responseType: "blob",
            headers: { Authorization: `Bearer ${authToken}` },
        });

        const contentTypeHeader = response.headers["content-type"];

        downloadBlob({
            blob: response.data,
            contentType:
                typeof contentTypeHeader === "string"
                    ? contentTypeHeader
                    : undefined,
            fileName,
            extension,
        });
    } catch (error) {
        console.error("Download failed:", error);
    }
};
